<template>
  <Card
    v-if="firstName !== ''"
    :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
    :modifiers="`py-5`"
  >
    <template slot="card-header">
      <h1 v-translate="{firstName: firstName}">Sorry, %{ firstName }</h1>
    </template>
    <template slot="card-body">
      <div class="row justify-content-center text-size-base mb-3">
        <div class="col-md-8 text-center">
          <p class="text-standard" v-translate>Your payment was unsuccessful.</p>
        </div>
      </div>
      <div class="form-group row justify-content-center mb-0">
        <div class="col-md-6 text-center">
          <router-link to="/enrolment/confirmation" class="btn btn-primary" v-translate>Continue</router-link>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import { mapState } from "vuex";
import Card from "@C/Card.vue";

export default {
  name: "FailedPayment",
  mounted() {
    // If no first name then no enrolment
    // so return to home.
    if (this.firstName === "") {
      this.$router.push("/");
    }
  },
  components: {
    Card
  },
  computed: {
    ...mapState({
      firstName: state => state.Enrolment.user.first_name
    })
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Enrolment/FailedPayment.vue